import React from "react";
import Helmet from "react-helmet";

export default props => (
  <Helmet>
    <html lang={"en"} />

    <title>{props.en.siteName}</title>
    <meta property="og:title" content={props.siteName} />

    <meta name="author" content={props.en.titleSuffix} />
    <meta name="owner" content={props.en.titleSuffix} />

    <meta name="description" content={props.en.fallbackSeo.description} />
    <meta name="abstract" content={props.en.fallbackSeo.description} />
    <meta name="summary" content={props.en.fallbackSeo.description} />
    <meta
      property="og:description"
      content={props.en.fallbackSeo.description}
    />

    <meta property="og:image" content={props.en.fallbackSeo.image.path} />

    <link rel="shortcut icon" type="image/x-icon" href={props.favicon.path} />
  </Helmet>
);

export const SearchSeo = props => {
  const title = props.searchQuery
    ? `${props.globalSeo.en.siteName} - Search: ${props.searchQuery}`
    : `${props.globalSeo.en.siteName} - Search`;

  return (
    <Helmet>
      <title>{title}</title>,
      <meta property="og:title" content={title} />
    </Helmet>
  );
};

export const ProjectSeo = props => {
  const meta = props.seoMetaTags.map((mt, i) => {
    switch (mt.tagName) {
      case "title":
        return <title key={i}>{mt.content}</title>;
      case "meta": {
        if (mt.attributes.name) {
          return (
            <meta
              key={i}
              name={mt.attributes.name}
              content={mt.attributes.content}
            />
          );
        }
        return null;
      }
      default:
        return null;
    }
  });
  return <Helmet>{meta}</Helmet>;
};



// WEBPACK FOOTER //
// ./src/templates/meta.js